<!-- Navigation Bar -->
<nav class="main-navbar py-2 fixed-top navbar-expand-lg" [ngClass]="{'scrolled': isScrolled}">
  <div class="container">

    <!-- Logo -->
    <a class="navbar-brand" routerLink="/">
      <img src="../../../assets/common/black-logo.png" alt="Kalpita Technologies">
    </a>

    <!-- Mobile Menu Toggler (Hamburger Icon) -->
    <button class="navbar-toggler d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasKalpita"
      aria-controls="offcanvasKalpita">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Offcanvas Menu for Mobile & Desktop Links -->
    <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasKalpita" aria-labelledby="offcanvasKalpitaLabel"
      #offcanvasElement> <!-- ← added this reference -->

      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasKalpitaLabel">
          <a class="navbar-brand" routerLink="/">
            <img src="../../../assets/common/black-logo.png" alt="Kalpita Technologies" class="logo-img" loading="lazy">
          </a>
        </h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>

      <div class="offcanvas-body">
        <div class="navbar-nav-wrapper ms-auto d-flex flex-column flex-lg-row align-items-center">
          <ul class="nav gap-3 mb-0 flex-column flex-lg-row">
            <li class="nav-item">
              <a class="nav-link d-flex align-items-center" [ngClass]="{'active': showCapabilities}"
                (click)="toggleCapabilities()">Capabilities</a>
            </li>
            <li class="nav-item">
              <a class="nav-link d-flex align-items-center" [ngClass]="{'active': showSolutions}"
                (click)="toggleSolutions()">Solutions</a>
            </li>
            <li class="nav-item">
              <a class="nav-link d-flex align-items-center" [ngClass]="{'active': showResources}"
                (click)="toggleResources()">Resources</a>
            </li>
            <li class="nav-item">
              <a class="nav-link d-flex align-items-center" [ngClass]="{'active': showCareers}"
                (click)="toggleCareers()">Careers</a>
            </li>
            <li class="nav-item">
              <a class="nav-link d-flex align-items-center" [ngClass]="{'active': showGallery}"
                (click)="toggleGallery()">Gallery</a>
            </li>
            <li class="nav-item">
              <a class="nav-link d-flex align-items-center" [ngClass]="{'active': showAboutUs}"
                (click)="toggleAboutUs()">About Us</a>
            </li>
          </ul>

          <!-- CTA Button -->
          <div class="contact-btn-wrapper mt-3 mt-lg-0 ms-lg-3">
            <div class="contact-btn-floating-bg"></div>
            <button class="btn contact-btn" type="button" (click)="openContactModal()">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mega Menu Dropdown Components -->
  <div *ngIf="showCapabilities" class="dropdown-menu-custom" style="z-index:1000;">
    <app-capabilities-navcard (close)="showCapabilities = false"></app-capabilities-navcard>
  </div>
  <div *ngIf="showSolutions" class="dropdown-menu-custom" style="z-index:1000;">
    <app-solutions-navcard (close)="showSolutions = false"></app-solutions-navcard>
  </div>
  <div *ngIf="showResources" class="dropdown-menu-custom" style="z-index:1000;">
    <app-resources-navcard (close)="showResources = false"></app-resources-navcard>
  </div>
  <div *ngIf="showCareers" class="dropdown-menu-custom" style="z-index:1000;">
    <app-careers-navcard (close)="showCareers = false"></app-careers-navcard>
  </div>
  <div *ngIf="showGallery" class="dropdown-menu-custom" style="z-index:1000;">
    <app-gallery-navcard (close)="showGallery = false"></app-gallery-navcard>
  </div>
  <div *ngIf="showAboutUs" class="dropdown-menu-custom" style="z-index:1000;">
    <app-aboutus (close)="showAboutUs = false"></app-aboutus>
  </div>
</nav>